import { render, staticRenderFns } from "./pdf-content.vue?vue&type=template&id=f5ba18b2&scoped=true"
import script from "./pdf-content.vue?vue&type=script&lang=ts"
export * from "./pdf-content.vue?vue&type=script&lang=ts"
import style0 from "./pdf-content.vue?vue&type=style&index=0&id=f5ba18b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba18b2",
  null
  
)

export default component.exports